
import { Component, Vue } from 'vue-property-decorator';
import CameraPageShootMessageNormal from '@/components/CameraPageShootMessageNormal.vue';

@Component({
  components: {
    CameraPageShootMessageNormal
  }
})
export default class CameraPageShootFace extends Vue {
  private get strokeSize(): number {
    return Math.ceil(this.$store.getters['camera/faceOvalWidth'] / 70);
  }

  private get caution(): string {
    return this.$store.getters['auth/currentLanguageWarningMessage'];
  }
}
